












































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import FileUpload from "@/components/common/Inputs/FileUpload.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { Locales } from "@/i18n/locales";
@Component({
  components: {
    FileUpload,
  },
})
export default class ArchiveManager extends Vue {
  headers = _app.archiveHeadersAdmin;
  items = [];
  dialog = false;
  snackBarColor: string = "red";
  snackbar: boolean = false;
  message: string = "";
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;
  onAddFiles(e, doc) {
    const { name, type, size } = e;
    let formData = new FormData();
    formData.append("file", e);
    this.$services.archive.Archive(formData).then((data) => {
      if (data.Result == "OK") {
        this.items = data.Record;
        this.dialog = false;
        this.snackbar = true;
        this.snackBarColor = "green";
        this.message = data.Message;
      } else {
        this.dialog = false;
        this.snackbar = true;
        this.snackBarColor = "red";
        this.message = data.Message;
      }
    });
  }
  addData() {
    this.$router.push({
      name: "CreateArchiveComponent",
    });
  }
  updateData(item) {
    this.$router.push({
      name: "UpdateArchiveComponent",
      params: { archiveId: item.ArchiveCallId },
    });
  }
  archivedelete(item) {
    if (confirm("Are you sure to delete this record?")) {
      this.$services.archive.deleteArchive(item.ArchiveCallId).then((data) => {
        if (data.Result == "OK") {
          this.snackbar = true;
          this.snackBarColor = "green";
          this.message = data.Message;
          this.$services.archive.getArchive().then((data) => {
            if (data.Result == "OK") {
              this.items = data.Record;
            }
          });
        } else {
          this.snackbar = true;
          this.snackBarColor = "red";
          this.message = "Failed to save Data";
        }
      });
    }
  }
  formatDate(date: any) {
    return utils.formatDate(date);
  }
  currencyFormat(val: any, format: any) {
    return utils.formatCurrency(val, format, this.defaultLocale);
  }
  mounted() {
    this.headers.map((x) => {
      x.text = this.$t(x.text);
    });
    this.$services.archive.getArchive().then((data) => {
      if (data.Result == "OK") {
        this.items = data.Record;
      }
    });
  }
}
